module.exports = __webpack_public_path__ + "img/newsbg.072820b5.png";